export default class NavigationMobile {
  constructor($el) {
    this.options = {
      submenuClass: 'navigation__level',
      submenuOpenClass: 'navigation__level--open',
      submenuContentInnerClass: 'navigation__level-content-inner',
      sublevelClass: 'navigation__sublevel',
      sublevelOpenClass: 'navigation__sublevel--open',
      itemClass: 'navigation__item',
      linkClass: 'navigation__link[aria-controls]',
      backLinkClass: 'navigation__sublevel-close',
    };

    this.$el = $el;
    this.$links = this.$el.querySelectorAll(`.${this.options.linkClass}`);
    this.$backLinks = this.$el.querySelectorAll(`.${this.options.backLinkClass}`);
  }

  init() {
    this.$links.forEach(($link) => {
      $link.addEventListener('click', this.open);
    });

    this.$backLinks.forEach(($link) => {
      $link.addEventListener('click', this.back);
    });
  }

  deInit() {
    this.$links.forEach(($link) => {
      $link.removeEventListener('click', this.open);
    });

    this.$backLinks.forEach(($link) => {
      $link.removeEventListener('click', this.back);
    });
  }

  setNavHeight($el) {
    const $levelContentInner = $el.closest(`.${this.options.submenuContentInnerClass}`);
    const openSubmenuRect = $el.getBoundingClientRect();
    let targetHeight = 0;

    if ($levelContentInner) {
      const levelContentInnerRect = $levelContentInner.getBoundingClientRect();

      if (openSubmenuRect.height > levelContentInnerRect.height) {
        $levelContentInner.style.height = `${openSubmenuRect.height - 60}px`;
      } else {
        $el.style.height = `${levelContentInnerRect.height}px`;
      }

      const submenuRect = $el.closest(`.${this.options.submenuClass}`).getBoundingClientRect();

      targetHeight = submenuRect.height;
    } else {
      targetHeight = openSubmenuRect.height;
    }

    this.$el.style.height = `${targetHeight}px`;
  }

  open = (event) => {
    const $target = event.currentTarget;

    if ($target) {
      const controls = $target.getAttribute('aria-controls');
      const $submenu = document.getElementById(controls);

      if ($submenu) {
        event.preventDefault();
        const $submenuBackLink = $submenu.querySelector(`.${this.options.backLinkClass}`);

        if ($submenu.classList.contains('navigation__sublevel')) {
          $submenu.classList.add(this.options.sublevelOpenClass);
        } else {
          $submenu.classList.add(this.options.submenuOpenClass);
        }
        $target.setAttribute('aria-expanded', 'true');

        this.setNavHeight($submenu);

        this.timer = setTimeout(() => {
          $submenuBackLink.focus();
        }, 100);
      }
    }
  }

  back = (event) => {
    const $target = event.currentTarget;
    if ($target) {
      event.preventDefault();

      const $targetParentItem = $target.closest(`.${this.options.itemClass}`);
      const $targetLink = $targetParentItem.querySelector(`.${this.options.linkClass}`);
      const controlsId = $target.getAttribute('aria-controls');
      $targetLink.setAttribute('aria-expanded', 'false');

      const $submenu = document.getElementById(controlsId);

      if ($submenu.classList.contains('navigation__sublevel')) {
        $submenu.classList.remove(this.options.sublevelOpenClass);
      } else {
        $submenu.classList.remove(this.options.submenuOpenClass);
      }

      const $levelContentInner = $submenu.closest(`.${this.options.submenuContentInnerClass}`);
      if ($levelContentInner) {
        $levelContentInner.removeAttribute('style');
      }

      this.$el.removeAttribute('style');
      this.setNavHeight(document.getElementById($target.dataset.target));

      this.timer = setTimeout(() => {
        $targetLink.focus();
      }, 100);
    }
  }
}
